export default __webpack_public_path__ + "static/media/A8.7ac4af78.jpg";